// src/redux/store.ts
import { isProd } from '@/services/constants/app';
import { configureStore } from '@reduxjs/toolkit';
import { thunk } from 'redux-thunk';
import rootReducer from './reducers';

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
    devTools: !isProd,
});

console.log('Started redux store in isDevelopment', !isProd, 'with API URL', process.env.NEXT_PUBLIC_BASE_URL);

export type RootState = ReturnType<typeof rootReducer>;

export type AppDispatch = typeof store.dispatch;

export type AppThunk<ReturnType = void> = (dispatch: AppDispatch, getState: () => RootState) => ReturnType;

export type dispatchType = { type: string; payload: any };

export { store as default };

